import { z } from 'zod/v4';

/**
 * Top-level container for general dashboard settings that affect things at the
 * dashboard level (e.g. rendering panel groups as tabs, dashboard-level
 * description, etc.).
 *
 * Intentionally starts empty - new fields are added here as features are built.
 */
export const generalSchema = z.object({});

export interface GeneralDefinition extends z.TypeOf<typeof generalSchema> {}
